import { render, staticRenderFns } from "./Add1.vue?vue&type=template&id=15ec2bde&scoped=true"
import script from "./Add1.vue?vue&type=script&lang=js"
export * from "./Add1.vue?vue&type=script&lang=js"
import style0 from "./Add1.vue?vue&type=style&index=0&id=15ec2bde&prod&lang=less"
import style1 from "./Add1.vue?vue&type=style&index=1&id=15ec2bde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec2bde",
  null
  
)

export default component.exports